export enum LanguageEnum {
    PT_BR = 'pt-br',
    EN_US = 'en-us',
    ES_ES = 'es-es'
}
